import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import {
  ScatterPlotOutlined,
  TrendingUpOutlined,
  RouteOutlined,
  AutoAwesomeOutlined,
} from '@mui/icons-material';
import Container from '../../components/LandingPage/Container';

/* eslint-disable react/prop-types */

const Cisp1Card: React.FC<{ icon: React.ReactNode; description: string }> = ({
  icon,
  description,
}) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      gap="13px"
      padding="25px 21px"
      bgcolor="var(--acer-green)"
      width="100%"
    >
      {icon}
      <Typography
        color="white"
        fontSize="20px"
        fontWeight="500"
        lineHeight="30px"
        letterSpacing="0.19px"
      >
        {description}
      </Typography>
    </Box>
  );
};

const Cisp1: React.FC = () => {
  const cisp1Cards = [
    {
      icon: <ScatterPlotOutlined />,
      description: 'Mais de 10 anos criando soluções para vendas corporativas',
    },
    {
      icon: <AutoAwesomeOutlined />,
      description: 'Projetos com grandes marcas do setor de tecnologia',
    },
    {
      icon: <RouteOutlined rotate="45deg" />,
      description: 'Plataforma digital própria, com integração ponta a ponta',
    },
    {
      icon: <TrendingUpOutlined />,
      description: 'Foco total em gerar valor para revendas e seus clientes',
    },
  ];

  return (
    <Box bgcolor="var(--acer-dark)">
      <Container>
        <Box
          display="flex"
          flexDirection={{ xs: 'column', md: 'row' }}
          gap={{ xs: '27px', md: '111px' }}
          width="100%"
        >
          <Box
            display="flex"
            flexDirection="column"
            gap="27px"
            width={{ xs: '100%', md: '465px' }}
            padding={{ xs: '41px 0 0 0', md: '112px 0' }}
          >
            <img width="150px" height="auto" src="/images/cisp1-white-logo.png" alt="CISP1" />
            <Typography
              color="white"
              fontSize="34px"
              fontWeight="600"
              lineHeight="44px"
              letterSpacing="0"
            >
              Por que a CISP1 eleva seu negócio ao próximo nível junto da Acer?
            </Typography>
            <Typography
              color="white"
              fontSize="16px"
              fontWeight="400"
              lineHeight="24px"
              letterSpacing="0.5px"
            >
              A CISP1 é especialista em e-commerce B2B e modelos digitais para a indústria de
              tecnologia.
            </Typography>
            <Typography
              color="white"
              fontSize="16px"
              fontWeight="400"
              lineHeight="24px"
              letterSpacing="0.5px"
            >
              Junto com a Acer, criamos uma plataforma que simplifica a revenda, conecta fabricantes
              a clientes finais e aumenta a margem das empresas, com menos fricção, mais escala e
              100% digital.
            </Typography>
          </Box>
          <Box
            padding={{ xs: '0 0 41px 0', md: '89px 0' }}
            width={{ xs: '100%', md: '561px' }}
            display="flex"
            flexDirection="column"
            gap="27px"
          >
            <Grid container spacing={1}>
              {cisp1Cards.map(cisp1Card => (
                <Grid item lg={6} width="100%" key={cisp1Card.description}>
                  <Cisp1Card icon={cisp1Card.icon} description={cisp1Card.description} />
                </Grid>
              ))}
            </Grid>
            <Typography
              color="var(--acer-green)"
              fontSize="18px"
              fontWeight="500"
              lineHeight="30px"
              letterSpacing="0.19px"
            >
              Com a CISP1 por trás da operação, a sua revenda tem tecnologia, estrutura e
              inteligência comercial para crescer com a Acer.
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Cisp1;
